module.exports = __webpack_public_path__ + "img/icon-ai.cdf8f1b1.png";